import React, { Fragment, useContext } from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import InfoToolTip from '../../../../../../common/infoToolTip';
import { MarkupListContext } from '../../../../contexts';

const Respondent = ({ respondentId, areas, selected }) => {
  const {
    demosTitle, demosText, toggleRespondent, hintMessageEye,
    respondentIsHidden, respondentClasses, getColor, toggleHighlight,
    hintMessageMarkupType, toggleMarkupVisible

  } = useContext(MarkupListContext);

  const handleToggleRespondent = (respondentId) => () => {
    toggleRespondent(respondentId);
  };

  const handleToggleHighlight = (respondent, isSelected) => () => {
    toggleHighlight(respondent, isSelected);
  };

  const handleToggleMarkupVisible = (area) => (event) => {
    event.stopPropagation();
    toggleMarkupVisible(area);
  };

  return (
    <div className={ selected ? "gsc" : "gc" }>
      <div className="summary-markup_comment -header">
        <div className="summary-markup_comment_author">
          Respondent { respondentId }
          <br />
          {
            map((areas[0]?.demos || []), (demo, index) => (
              <Fragment key={ `demo-${index}-${demo[0]}-${demo[1]}` }>
                <b>{ demosTitle(demo) }</b>
                { ' = ' }
                { demosText(demo) }
                { '; ' }
              </Fragment>
            ))
          }
        </div>
        <span
          className="summary-markup_comment_action icon-link -no-text"
          role="button"
          onClick={ handleToggleRespondent(respondentId) }
        >
          <InfoToolTip
            className="-pointer"
            remote
            text={ <>{ hintMessageEye(respondentId) }</> }
            position="top-left"
            attachTo={
              <>
                {
                  respondentIsHidden(respondentId) ? (
                    <svg className="icon-link_icon icon -eye-closed">
                      <use xlinkHref="#svg_eye-closed" />
                    </svg>
                  ) : (
                    <svg className="icon-link_icon icon -eye-open">
                      <use xlinkHref="#svg_eye-open" />
                    </svg>
                  )
                }
              </>
            }
          />
        </span>
      </div>
      {
        map(areas, (area) => (
          <div
            id={ `resp-${area.id}` }
            key={ `area-${area.id}` }
            className={
              classnames(
                "summary-markup_comment",
                respondentClasses(area, true)
              )
            }
            style={ { color: (area.hidden ? '' : getColor(area.reaction)) } }
            onClick={ handleToggleHighlight(area, true) }
          >
            <div className="summary-markup_comment_comment">{ area.comment || '---' }</div>
            <div className="summary-markup_comment_tools">
              <InfoToolTip
                remote
                text={ <>{ hintMessageMarkupType(area.markup_type) }</> }
                position="top-left"
                attachTo={
                  <>
                    {
                      area.markup_type === 'text' &&
                      <svg className="icon -reaction-t summary-markup_comment_icon">
                        <use xlinkHref="#svg_reaction-t" />
                      </svg>
                    }
                    {
                      area.markup_type === 'area' &&
                      <svg className="icon -reaction summary-markup_comment_icon">
                        <use xlinkHref="#svg_reaction" />
                      </svg>
                    }
                  </>
                }
              />
              {
                area.markup_visible ? (
                  <svg
                    className="icon-link_icon icon -eye-open -pointer"
                    onClick={ handleToggleMarkupVisible(area) }
                  >
                    <use xlinkHref="#svg_eye-open" />
                  </svg>
                ) : (
                  <svg
                    className="icon-link_icon icon -eye-closed -pointer"
                    onClick={ handleToggleMarkupVisible(area) }
                  >
                    <use xlinkHref="#svg_eye-closed" />
                  </svg>
                )
              }
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default Respondent;
